import { Component, Input, OnInit } from '@angular/core';
import { SelectedSommelierService } from '../../services/selected-sommelier.service';

@Component({
  selector: 'app-metro-order-card-item',
  templateUrl: './metro-order-card-item.component.html',
  standalone: false
})
export class MetroOrderCardItemComponent {
  @Input() dateOrder!: string;
  @Input() wineryName!: string;
  @Input() status!: string;
  @Input() itemCount!: number;
  @Input() totalPrice!: number;
  @Input() id!: number;
  @Input() navigationPath: string = 'order'; // Ruta a la que navegar
  private _orderNumber!: string;

  @Input()
  set orderNumber(value: string | number) {
    this._orderNumber = value?.toString() || '';
  }
  get orderNumber(): string {
    return this._orderNumber;
  }

  @Input() isSommelierView: boolean = false;

  get displayLabel(): string {
    return this.isSommelierView ? this._orderNumber : `Order #${this._orderNumber}`;
  }

  @Input() queryParams: any = null;

  constructor(private selectedSommelierService: SelectedSommelierService) { }

  redirectToDetails() {
    this.selectedSommelierService.navigate([this.navigationPath, this.id.toString()], {
      queryParams: this.queryParams
    });
  }

}
